import { CodeLanguagesExtension } from "./code-languages";
import { DebugMenuExtension } from "./debug-menu";
import { HighlightMarkExtension } from "./highlight";
import { HtmlExtension } from "./html";
import { InlineInsertMenu } from "./inline-insert-menu";
import { LinkEditBoxExtension } from "./link-edit-box";
import { LinkPreviewExtension } from "./link-preview";
import { LocalFilesExtension } from "./local-files";
import { MermaidExtension } from "./mermaid";
import { BusinessEntitiesExtension } from "./mystekz-business-entities";
import { DomainTermsExtension } from "./mystekz-domain-terms";
import { DomainsExtension } from "./mystekz-domains";
import { ProcessesExtension } from "./mystekz-processes";
import { ProductsExtension } from "./mystekz-products";
import { RolesExtension } from "./mystekz-roles";
import { StrikethroughMarkExtension } from "./strikethrough";
import { TableExtension } from "./table";
import { TextTypeMenuExtension } from "./text-type-menu";
import { ToDoListItemExtension } from "./to-do-list-items";

export const ExtensionMap = {
    "mystekz-business-entities": () => new BusinessEntitiesExtension(),
    "mystekz-domain-terms": () => new DomainTermsExtension(),
    "debug-menu": () => new DebugMenuExtension(),
    "mystekz-domains": () => new DomainsExtension(),
    "inline-insert-menu": () => new InlineInsertMenu(),
    "link-edit-box": () => new LinkEditBoxExtension(),
    "local-files": () => new LocalFilesExtension(),
    "mystekz-processes": () => new ProcessesExtension(),
    "mystekz-products": () => new ProductsExtension(),
    "mystekz-roles": () => new RolesExtension(),
    "strikethrough": () => new StrikethroughMarkExtension(),
    "table": () => new TableExtension(),
    "highlight": () => new HighlightMarkExtension(),
    "text-type-menu": () => new TextTypeMenuExtension(),
    "to-do-list-items": () => new ToDoListItemExtension(),
    "html": () => new HtmlExtension(),
    "mermaid": () => new MermaidExtension(),
    "code-languages": () => new CodeLanguagesExtension(),
    "link-preview": () => new LinkPreviewExtension(),
};

export type ExtensionKeys = keyof typeof ExtensionMap;
